import { InfoOutlined } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  CardProps,
  Divider,
  IconButton,
  Popover,
  Typography,
  useTheme,
} from "@mui/material";
import { Markdown, PimoReactComponent } from "@pimo/pimo-app-builder";
import { useState } from "react";

export interface DoubleNumberCardV2Props {
  title: string;
  infoBoxText?: string;
  textColor?: string;
  content1: {
    value: string;
    label: string;
  };
  content2: {
    value: string;
    label: string;
  };
  cardProps?: CardProps;
}

export const DoubleNumberCardV2: PimoReactComponent<
  DoubleNumberCardV2Props
> = ({ title, infoBoxText, content1, content2, textColor, cardProps }) => {
  const theme = useTheme();
  const [infoIconPopoverAnchor, setInfoIconPopoverAnchor] =
    useState<null | HTMLElement>();
  return (
    <Card
      sx={{
        bgcolor: theme.palette.primary.light,
        boxShadow: "none",
        borderRadius: "12px",
        color: theme.palette.primary.contrastText,
        height: "100%",
        ...cardProps?.sx,
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: theme.spacing(1),
            boxShadow: "none",
          }}
        >
          <Typography variant="h5" sx={{ fontSize: 16 }}>
            {title}
          </Typography>
          <IconButton
            onClick={(e) => setInfoIconPopoverAnchor(e.target as HTMLElement)}
          >
            <InfoOutlined />
          </IconButton>
          <Popover
            open={!!infoIconPopoverAnchor}
            anchorEl={infoIconPopoverAnchor}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={() => setInfoIconPopoverAnchor(null)}
          >
            <Typography
              component="div"
              sx={{ maxWidth: "500px", px: 2, lineHeight: "20px" }}
            >
              <Markdown>{infoBoxText || ""}</Markdown>
            </Typography>
          </Popover>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              gap: 1,
              width: "50%",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: textColor ?? theme.palette.primary.contrastText,
                wordBreak: "break-word",
              }}
            >
              {content1.value}
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.grey[600] }}>
              {content1.label}
            </Typography>
          </Box>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ bgcolor: theme.palette.grey[300], mx: theme.spacing(2) }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              gap: 1,
              width: "50%",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                wordBreak: "break-word",
                color: textColor ?? theme.palette.primary.contrastText,
              }}
            >
              {content2.value}
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.grey[600] }}>
              {content2.label}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DoubleNumberCardV2;
